export enum ClaimSteps {
    CustomerInfoStep = 'claimFormStep_title_CustomerInfoStep',
    ConfirmationStep = 'claimFormStep_title_ConfirmationStep',
    RewardStep = 'claimFormStep_title_RewardOptionsStep',
    DetailStep = 'claimFormStep_title_DetailStep',
    PurchaseTypeStep = 'claimFormStep_title_PurchaseTypeStep',
    ReviewStep = 'claimFormStep_title_ReviewStep',
    RewardOptionSelectionStep = 'claimFormStep_title_RewardOptionSelectionStep',
}
